import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import SubHeader from "../SubComp/SubHeader/SubHeader";
import "./Checkout.css";

const Checkout = () => {


  return (

    <div className="Wishlist">
      <Header />
      <SubHeader title="Checkout" text="Checkout" width='container' />
      <div className="cart-container py-5">
        <div className="container ">
          <div className="row">

            <div className="col-lg-8">
              <table className="Wishlist_table table table-borderless text-white">

                <tbody>

                  <tr className='btm_border_dash'>

                    <td className="product-thumbnail w30">
                      <Link to="" >
                        <div className="cart-img">
                          <img src={require("../../Asset/blog/Group 229.png")} alt="Product" />
                        </div>
                      </Link>
                    </td>
                    <td className="product-name w40">
                      Abstract Oil Painting
                      <br />
                      By <span className="cl-pm">Kaven Morgan</span>,
                      <span> Size: 15”x10”</span>
                    </td>
                    <td className="product-stock-status w15">1</td>
                    <td className="product-price w15">$150.00</td>

                  </tr>

                  <tr className='btm_border_dash'>

                    <td className="product-thumbnail w30">
                      <Link to="" >
                        <div className="cart-img">
                          <img src={require("../../Asset/blog/Group 229.png")} alt="Product" />
                        </div>
                      </Link>
                    </td>
                    <td className="product-name w40">
                      Abstract Oil Painting
                      <br />
                      By <span className="cl-pm">Kaven Morgan</span>,
                      <span> Size: 15”x10”</span>
                    </td>
                    <td className="product-stock-status w15">1</td>
                    <td className="product-price w15">$150.00</td>

                  </tr>

                </tbody>
              </table>
            </div>

            <div className="col-lg-4">
              <div className="col-lg-4">
                <div className="left-container">
                  <h4 className="p-4">Select Your Payment Method</h4>
                  <div className="d-flex justify-content-center align-items-center mb-4">
                    <div className="payment-img mb-3">
                      <img
                        src={require("../../Asset/checkout/mastercard.png")}
                        alt="Visa Card"
                      />
                    </div>
                    <div className="payment-img mb-3">
                      <img
                        src={require("../../Asset/checkout/visa.png")}
                        alt="Visa Card"
                      />
                    </div>
                    <div className="payment-img mb-3">
                      <img
                        src={require("../../Asset/checkout/mastercard.png")}
                        alt="Visa Card"
                      />
                    </div>
                    <div className="payment-img mb-3">
                      <img
                        src={require("../../Asset/checkout/visa.png")}
                        alt="Visa Card"
                      />
                    </div>
                  </div>
                  <div className="container">
                    <form>
                      <div className="mb-3">
                        <label for="exampleFormControlInput1" className="form-label">
                          Card Number
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter your 16 digit number"
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          for="exampleFormControlInput1"
                          className="form-label"
                        >
                          Card Holder Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter card holder name"
                        />
                      </div>
                      <div className="row">
                        <div className="my-3 col-md-6">
                          <label
                            for="exampleFormControlInput1"
                            className="form-label"
                          >
                            CCV
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter CCV"
                          />
                        </div>
                        <div className="my-3 col-md-6">
                          <label
                            for="exampleFormControlInput1"
                            className="form-label"
                          >
                            Expire Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            placeholder="Enter Date"
                          />
                        </div>
                      </div>
                      <button type="submit" class="fixed_btn border1 w-100 my-3">Submit</button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>

  );
};
export default Checkout;
